import React from 'react';
import { Skeleton } from 'gatorcomponents';
import * as Styles from './ChatSkeleton.styles';

const ChatSkeleton = () => (
  <Styles.Wrapper>
    <Skeleton width="100%" height="70px" />
    <Styles.ChatWrapper>
      <Skeleton width="36px" height="36px" variant="circle" />
      <Skeleton width="100%" height="80px" />
    </Styles.ChatWrapper>
  </Styles.Wrapper>
);

export default ChatSkeleton;
